import React, { PureComponent } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import LoginComponents, { FormRegistration, FormTechnicalProblem } from '../../components/Login';
import { loadProfile } from '../../actions/profile';
import {
  inviteFormSending,
  numberFormSending,
  smsFormSending,
  restoreFormSending,
  reconnectFormSending,
  userLogout
} from '../../actions/loginForms';
import styles from './Login.scss';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Tariffs from 'assets/images/tariffs.svg';
import Notification from '../../components/Notification/Notification';

class Login extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      toggle: false,
      isScrollButtonVisible: false,
      isTechnicalProblem: false,
      name: '',
      surName: '',
      currentWork: '',
      phoneNumber: '',
      email: ''
    };

    this.handleRegistrationError = this.handleRegistrationError.bind(this);
    this.handleRegistrationSuccessfully = this.handleRegistrationSuccessfully.bind(this);
    this.handleScrollPage = this.handleScrollPage.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScrollPage);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScrollPage);
  }

  handleScrollPage() {
    const { isScrollButtonVisible } = this.state;
    if (pageYOffset > 400 && !isScrollButtonVisible) {
      this.setState({ isScrollButtonVisible: true });
    } else if (pageYOffset <= 400 && isScrollButtonVisible) {
      this.setState({ isScrollButtonVisible: false });
    }
  }

  handleRegistrationSuccessfully() {
    this.setState({ toggle: false });
  }

  handleRegistrationError() {
    this.setState({ toggle: false, isTechnicalProblem: true });
  }

  handleScrollToUp() {
    window.scroll({
      top: 0,
      behavior: 'smooth'
    });
  }

  render() {
    const { loginState, t, history, ...rest } = this.props;
    const { isScrollButtonVisible, toggle, isTechnicalProblem } = this.state;

    const LoginComponent = LoginComponents[`Form${loginState}`];

    return (
      <div className={styles.Login}>
        <div className={styles.Header}>
          <div className={styles.Divider} />
          <a href="https://nedvex.ru/"><div className={styles.Logo} /></a>
          <div className={styles.Telephones}>
            {/* <span className={styles.Tariffs} onClick={() => history.push('/rates')}>
              <img src={Tariffs} />
              {t('containers.login.tariffs')}
            </span> */}
            <a href={`tel:${t('containers.login.phone1Link')}`}>
              <div className={styles.Telephone}>
                <div className={styles.IconTelephone} />
                <span>
                  {t('containers.login.phone1')}
                </span>
              </div>
            </a>
            <a href={`tel:${t('containers.login.phone2Link')}}`}>
              <div className={styles.Telephone}>
                <div className={styles.IconTelephone} />
                <span>
                  {t('containers.login.phone2')}
                </span>
              </div>
            </a>
          </div>
        </div>
        <div className={styles.Content}>
          <div className={styles.Title}>
            <h1>
              {t('containers.login.title1')}
            </h1>
            <h2>
              {t('containers.login.title2')}
            </h2>
          </div>
          <div className={styles.Info}>
            <div className={styles.Left}>
              <div className={styles.Description}>
                <span>
                  {t('containers.login.description1')}
                </span>
                <span>
                  {t('containers.login.description2')}
                </span>
              </div>
              <div className={styles.ImagesGroup}>
                <div className={styles.Background} />
                <div className={styles.AppButtons}>
                  <a href="https://apps.apple.com/ru/app/nedvex/id1079767992" rel="noopener noreferrer" target="_blank"><div className={styles.AppStore} /></a>
                  <a href="https://play.google.com/store/apps/details?id=ru.andrroider.apps.nedvex&hl=ru&gl=US" rel="noopener noreferrer" target="_blank"><div className={styles.GooglePlay} /></a>
                </div>
                <div className={styles.MackBook} />
              </div>
            </div>
            <div className={styles.Right}>
              <LoginComponent {...rest} onOpenRegistration={() => this.setState({ toggle: true })} />
            </div>
          </div>
          <div className={styles.About}>
            <div className={styles.SubGroup}>
              <div className={styles.Item}>
                <h1>
                  3 500
                </h1>
                <span>
                  {t('containers.login.about1')}
                </span>
              </div>
              <div className={styles.Item}>
                <h1>80%</h1>
                <span>
                  {t('containers.login.about2')}
                </span>
              </div>
            </div>
            <div className={styles.SubGroup}>
              <div className={styles.Item}>
                <h1>2 000</h1>
                <span>
                  {t('containers.login.about3')}
                </span>
              </div>
              <div className={styles.Item}>
                <h1>50+</h1>
                <span>
                  {t('containers.login.about4')}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.Footer} >
          <div className={cn(styles.SubGroup, styles.SubGroup1)}>
            <div dangerouslySetInnerHTML={{ __html: t('containers.login.footer1') }} />
          </div>
          <div className={cn(styles.SubGroup, styles.SubGroup2)}>
            <a
              href="https://nedvex.ru/%D0%90%D1%80%D1%85%D0%B8%D0%B2.zip"
              target="_blank"
              dangerouslySetInnerHTML={{ __html: t('containers.login.footer2') }}
            />
          </div>
          <div className={cn(styles.SubGroup, styles.SubGroup3)}>
            <div style={{ textAlign: 'center' }}>
              {t('containers.login.footer3')}
              <br />
              <a href="https://app.nedvex.ru/policy" target="_blank">
                {t('containers.login.docs')}
              </a>
            </div>
          </div>
        </div>
        {isScrollButtonVisible &&
          <div className={styles.ScrollButton} onClick={this.handleScrollToUp}>
            <div className={styles.ScrollButtonIcon} />
          </div>
        }1
        {toggle &&
          <FormRegistration
            handleRegistrationSuccessfully={this.handleRegistrationSuccessfully}
            handleRegistrationError={this.handleRegistrationError}
            handleCloseModal={() => this.setState({ toggle: false })}
          />
        }
        {isTechnicalProblem && <FormTechnicalProblem handleCloseModal={() => this.setState({ isTechnicalProblem: false })} />}
      </div>
    );
  }
}

export default connect(
  state => state.loginForms,
  {
    inviteFormSending,
    numberFormSending,
    smsFormSending,
    restoreFormSending,
    reconnectFormSending,
    userLogout,
    loadProfile
  })(withTranslation()(withRouter(Login)));



// WEBPACK FOOTER //
// ./src/containers/Login/Login.js